import { useEffect } from "react";
import posthog from "../../../configs/PostHogConfig";
import { useAuth } from "../firebase/useAuth";

export const usePostHog = () => {
  const { user, uid, email } = useAuth();

  useEffect(() => {
    if (user && uid) {
      posthog.identify(uid, {
        email: email,
        name: user.displayName || email,
      });
    }
  }, [user, uid, email]);

  return posthog;
};
